<template>
  <div class="part">
    <div class="fta_desc">
      <ul>
        <li v-for="(item, index) in rules" :key="`rule-${index}`">
          <span class="sn"><span>{{index + 1}}</span></span>
          <span class="title">{{item.name}}</span>
          <span class="desc">{{item.desc}}</span>
        </li>
      </ul>
    </div>
    <section class="fta_coo">
      <div class="caption">原产地预判定</div>
      <div class="special">
        <div :class="['item', 'wo', isSelectWo ? 'selected' : '']" @click.prevent="$emit('update:isSelectWo', !isSelectWo)">
          <img src="~@/assets/images/coo/image_wqhq.png" class="icon defalut_img">
          <img src="~@/assets/images/coo/image_wqhq2.png" class="icon selected_img">
          <div class="title">完全获取</div>
          <div class="desc">{{dataSet.wo ? '原产地完全获取' : '无'}}</div>
          <div class="ckbox_wrap">
            <img src="~@/assets/images/coo/icon_xuanzhong2.png" class="ckbox">
            <img src="~@/assets/images/coo/icon_xuanzhong.png" class="ckbox selected_ckbox">
          </div>
        </div>
        <div :class="['item', 'craft', isSelectCraft ? 'selected' : '']" @click.prevent="$emit('update:isSelectCraft', !isSelectCraft)">
          <img src="~@/assets/images/coo/image_tsgy.png" class="icon defalut_img">
          <img src="~@/assets/images/coo/image_tsgy2.png" class="icon selected_img">
          <div class="title">加工工序</div>
          <div class="desc">{{dataSet.specialCraft || '无'}}</div>
          <div class="ckbox_wrap">
            <img src="~@/assets/images/coo/icon_xuanzhong2.png" class="ckbox">
            <img src="~@/assets/images/coo/icon_xuanzhong.png" class="ckbox selected_ckbox">
          </div>
        </div>
      </div>
      <div class="special_msg" v-if="errData.goodsWo || errData.goodsWo === 0 || errData.goodsSpecialCraft || errData.goodsSpecialCraft === 0">
        <Alert type="error" show-icon closable v-if="errData.goodsWo || errData.goodsWo === 0">需满足原产地完全获取</Alert>
        <Alert type="error" show-icon closable v-if="errData.goodsSpecialCraft || errData.goodsSpecialCraft === 0">需具有加工工序</Alert>
      </div>
      <div class="rules">
        <Row class="items" :gutter="20">
          <Col span="12" class="rvc_item">
            <div class="items_wrap">
              <div class="items_title">
                <div class="items_title_value">原产地判定标准RVC</div>
                <div class="items_title_desc">满足以下任意一项即可</div>
              </div>
              <div class="items_rules">
                <Row class="item" :gutter="5">
                  <Col span="8" class="name"><div class="wrap"><span class="title">RVC标准：</span><span class="value">{{dataSet.rvc || '无'}}</span></div></Col>
                  <Col span="16" :class="['result', dataSet.rvc && (errData.goodsRvc || errData.goodsRvc === 0) ? 'error' : '']">
                    <div class="wrap" v-if="dataSet.rvc && (errData.goodsRvc || errData.goodsRvc === 0)"><span class="jg">RVC结果：{{errData.goodsRvc | toPercent}}</span><span class="bz">不满足{{dataSet.rvc}}</span></div>
                    <div class="wrap" v-else-if="dataSet.rvc && errData.ftaId"><span class="jg">RVC结果：</span><span class="mz" style="color:#00B55F;">满足</span></div>
                    <div class="wrap" v-else><span class="jg">RVC结果：</span><span class="df" style="color:#949494;">{{dataSet.rvc ? '-' : '无'}}</span></div>
                  </Col>
                </Row>
                <Row class="item" :gutter="5">
                  <Col span="8" class="name"><div class="wrap"><span class="title">累计规则：</span><span class="value">{{dataSet.cumulation || '无'}}</span></div></Col>
                  <Col span="16" :class="['result', dataSet.cumulation && (errData.goodsCumulation || errData.goodsCumulation === 0) ? 'error' : '']">
                    <div class="wrap" v-if="dataSet.cumulation && (errData.goodsCumulation || errData.goodsCumulation === 0)"><span class="jg">累计规则结果：{{errData.goodsCumulation | toPercent}}</span><span class="bz">不满足{{dataSet.cumulation}}</span></div>
                    <div class="wrap" v-else-if="dataSet.cumulation && errData.ftaId"><span class="jg">累计规则结果：</span><span class="mz" style="color:#00B55F;">满足</span></div>
                    <div class="wrap" v-else><span class="jg">累计规则结果：</span><span class="df" style="color:#949494;">{{dataSet.cumulation ? '-' : '无'}}</span></div>
                  </Col>
                </Row>
                <Row class="item" :gutter="5">
                  <Col span="8" class="name"><div class="wrap"><span class="title">特殊比例标准：</span><span class="value">{{dataSet.cumulationUnderdeveloped || '无'}}</span></div></Col>
                  <Col span="16" :class="['result', dataSet.cumulationUnderdeveloped && (errData.goodsCumulationUnderdeveloped || errData.goodsCumulationUnderdeveloped === 0) ? 'error' : '']">
                    <div class="wrap" v-if="dataSet.cumulationUnderdeveloped && (errData.goodsCumulationUnderdeveloped || errData.goodsCumulationUnderdeveloped === 0)">
                      <!-- <span class="jg">特殊比例结果：{{errData.goodsCumulationUnderdeveloped}}</span> -->
                      <span>特殊比例结果：</span>
                      <span class="bz">不满足{{dataSet.cumulationUnderdeveloped}}</span>
                    </div>
                    <div class="wrap" v-else-if="dataSet.cumulationUnderdeveloped && errData.ftaId">
                      <span class="jg">特殊比例结果：</span>
                      <span class="mz" style="color:#00B55F;">满足</span>
                    </div>
                    <div class="wrap" v-else>
                      <span class="jg">特殊比例结果：</span>
                      <span class="df" style="color:#949494;">{{dataSet.cumulationUnderdeveloped ? '-' : '无'}}</span>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col span="12" class="ctc_item">
            <div class="items_wrap">
              <div class="items_title">
                <div class="items_title_value">原产地判定标准CTC</div>
                <div class="items_title_desc">满足微小含量标准或同时满足CTC/排除CTC标准即可</div>
              </div>
              <div class="items_rules">
                <Row class="item" :gutter="5">
                  <Col span="8" class="name"><div class="wrap"><span class="title">CTC标准：</span><span class="value">{{dataSet.ctc || '无'}}</span></div></Col>
                  <Col span="16" :class="['result', dataSet.ctc && (errData.goodsCtc || errData.goodsCtc === 0) ? 'error' : '']">
                    <div class="wrap" v-if="dataSet.ctc && (errData.goodsCtc || errData.goodsCtc === 0)">
                      <span class="jg" v-if="errData.goodsCtc !== 0">CTC结果：{{errData.goodsCtc}}</span>
                      <span v-else>CTC结果：</span>
                      <span class="bz">不满足{{dataSet.ctc}}</span>
                    </div>
                    <div class="wrap" v-else-if="dataSet.ctc && errData.ftaId"><span class="jg">CTC结果：</span><span class="mz" style="color:#00B55F;">满足</span></div>
                    <div class="wrap" v-else><span class="jg">CTC结果：</span><span class="df" style="color:#949494;">{{dataSet.ctc ? '-' : '无'}}</span></div>
                  </Col>
                </Row>
                <Row class="item" :gutter="5">
                  <Col span="8" class="name"><div class="wrap"><span class="title">排除CTC标准：</span><span class="value">{{dataSet.excludedCtc || '无'}}</span></div></Col>
                  <Col span="16" :class="['result', dataSet.excludedCtc && (errData.goodsExcludedCtc || errData.goodsExcludedCtc === 0) ? 'error' : '']">
                    <div class="wrap" v-if="dataSet.excludedCtc && (errData.goodsExcludedCtc || errData.goodsExcludedCtc === 0)">
                      <span class="jg" v-if="errData.goodsExcludedCtc !== 0">排除CTC结果：{{errData.goodsExcludedCtc}}</span>
                      <span v-else>排除CTC结果：</span>
                      <span class="bz">不满足{{dataSet.excludedCtc}}</span>
                    </div>
                    <div class="wrap" v-else-if="dataSet.excludedCtc && errData.ftaId"><span class="jg">排除CTC结果：</span><span class="mz" style="color:#00B55F;">满足</span></div>
                    <div class="wrap" v-else><span class="jg">排除CTC结果：</span><span class="df" style="color:#949494;">{{dataSet.excludedCtc ? '-' : '无'}}</span></div>
                  </Col>
                </Row>
                <Row class="item" :gutter="5">
                  <Col span="8" class="name"><div class="wrap"><span class="title">微小含量标准：</span><span class="value">{{dataSet.tiny || '无'}}</span></div></Col>
                  <Col span="16" :class="['result', dataSet.tiny && (errData.goodsTiny || errData.goodsTiny === 0) ? 'error' : '']">
                    <div class="wrap" v-if="dataSet.tiny && (errData.goodsTiny || errData.goodsTiny === 0)"><span class="jg">微小含量结果：{{errData.goodsTiny | toPercent}}</span><span class="bz">不满足{{dataSet.tiny}}</span></div>
                    <div class="wrap" v-else-if="dataSet.tiny && errData.ftaId"><span class="jg">微小含量结果：</span><span class="mz" style="color:#00B55F;">满足</span></div>
                    <div class="wrap" v-else><span class="jg">微小含量结果：</span><span class="df" style="color:#949494;">{{dataSet.tiny ? '-' : '无'}}</span></div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        <Row class="items">
          <Col span="24" class="other_item">
            <div class="items_wrap">
              <div class="items_title">
                <div class="items_title_value">其他判定标准</div>
              </div>
              <div class="items_rules">
                <Row class="item">
                  <Col span="24" class="name"><div class="wrap" :style="dataSet.other ? '' : 'color:#949494;'">{{dataSet.other ? dataSet.other : '无'}}</div></Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <!--<div class="rules">-->
        <!--<Row class="item">-->
          <!--<Col span="4" class="name"><div class="wrap"><span class="title">RVC标准：</span><span class="value">{{dataSet.rvc || '无'}}</span></div></Col>-->
          <!--<Col span="8" class="result mr error" v-if="dataSet.rvc && errData.goodsRvc">-->
            <!--<div class="wrap"><span class="jg">RVC结果：{{errData.goodsRvc | toPercent}}</span><span class="bz">不满足{{dataSet.rvc}}</span></div>-->
          <!--</Col>-->
          <!--<Col span="4" class="name"><div class="wrap"><span class="title">微小含量：</span><span class="value">{{dataSet.tiny || '无'}}</span></div></Col>-->
          <!--<Col span="8" class="result error" v-if="dataSet.tiny && errData.goodsTiny">-->
            <!--<div class="wrap"><span class="jg">微小含量结果：{{errData.goodsTiny}}</span><span class="bz">不满足{{dataSet.tiny}}</span></div>-->
          <!--</Col>-->
        <!--</Row>-->
        <!--<Row class="item">-->
          <!--<Col span="4" class="name"><div class="wrap"><span class="title">累计规则：</span><span class="value">{{dataSet.cumulation || '无'}}</span></div></Col>-->
          <!--<Col span="8" class="result mr error" v-if="dataSet.cumulation && errData.goodsCumulation">-->
            <!--<div class="wrap"><span class="jg">累计规则结果：{{errData.goodsCumulation | toPercent}}</span><span class="bz">不满足{{dataSet.cumulation}}</span></div>-->
          <!--</Col>-->
          <!--<Col span="4" class="name"><div class="wrap"><span class="title">特殊比例：</span><span class="value">{{dataSet.cumulationUnderdeveloped || '无'}}</span></div></Col>-->
          <!--<Col span="8" class="result error" v-if="dataSet.cumulationUnderdeveloped && errData.goodsCumulationUnderdeveloped">-->
            <!--<div class="wrap"><span class="jg">特殊比例结果：{{errData.goodsCumulationUnderdeveloped | toPercent}}</span><span class="bz">不满足{{dataSet.cumulationUnderdeveloped}}</span></div>-->
          <!--</Col>-->
        <!--</Row>-->
        <!--<Row class="item">-->
          <!--<Col span="5" class="name"><div class="wrap"><span class="title">CTC标准：</span><span class="value">{{dataSet.ctc || '无'}}</span></div></Col>-->
          <!--<Col span="7" class="result mr error" v-if="dataSet.ctc && errData.goodsCtc">-->
            <!--<div class="wrap"><span class="jg">CTC标准结果：{{errData.goodsCtc}}</span><span class="bz">不满足{{dataSet.ctc}}</span></div>-->
          <!--</Col>-->
          <!--<Col span="5" class="name"><div class="wrap"><span class="title">排除CTC标准：</span><span class="value">{{dataSet.excludedCtc || '无'}}</span></div></Col>-->
          <!--<Col span="7" class="result error" v-if="dataSet.excludedCtc && errData.goodsExcludedCtc">-->
            <!--<div class="wrap"><span class="jg">排除CTC标准结果：{{errData.goodsExcludedCtc}}</span><span class="bz">不满足{{dataSet.excludedCtc}}</span></div>-->
          <!--</Col>-->
        <!--</Row>-->
        <!--<Row class="item">-->
          <!--<Col span="24" class="name"><div class="wrap">其他判定标准：{{dataSet.other ? dataSet.other : '无'}}</div></Col>-->
        <!--</Row>-->
      <!--</div>-->
    </section>
  </div>
</template>

<script>
export default {
  name: 'VoteContentPanel',
  props: {
    dataSet: {
      type: Object,
      default: () => { return {} },
      required: false
    },
    cooErrData: {
      type: Array,
      default: () => []
    },
    isSelectWo: {
      type: Boolean,
      default: false
    },
    isSelectCraft: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    rules () {
      let res = []
      let i = 1
      while (this.dataSet[`ruleName${i}`]) {
        res.push({ name: this.dataSet[`ruleName${i}`], desc: this.dataSet[`ruleDescription${i}`] || '' })
        i++
      }
      return res
    },
    errData () {
      return this._.find(this.cooErrData, d => d.ftaId === this.dataSet.ftaId) || {}
    }
  }
}
</script>
<style scoped>
  .fta_desc{
    background-color: #F9F9F9;
    padding: 12px 15px;
    margin: 5px 15px 20px;
  }
  .fta_desc li{
    font-size: 13px;
    margin-bottom: 6px;
  }
  .fta_desc li:last-child{
    margin-bottom: 0;
  }
  .fta_desc li .sn{
    background-color: #FFFFFF;
    border: 0.5px solid #1F8AFD;
    border-radius: 100%;
    color: #1F8AFD;
    font-size: 10px;
    margin-right: 2px;
    display: inline-block;
    width: 15px;
    height: 15px;
    text-align: center;
    vertical-align: middle;
    position: relative;
    top: -1px;
  }
  .fta_desc li .sn span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .fta_desc li .title{
    color: #333;
    padding-right: 10px;
  }
  .fta_desc li .desc{
    color: #999;
  }
  .caption{
    font-size: 1.4rem;
    color: #333;
    font-weight: bold;
    background: url("~@/assets/images/icons/show/guide.png") 0 center no-repeat transparent;
    background-size: 4px 12px;
    padding-left: 13px;
    margin-bottom: 15px;
    position: relative;
  }
  .special{
    display: flex;
    margin-left: 13px;
  }
  .special .item{
    border: 0.5px solid #D8D8D8;
    border-radius: 3px;
    position: relative;
    padding: 18px 20px 18px 66px;
    cursor: pointer;
    width: 180px;
  }
  .special .item.selected{
    border-color: #1F8AFD;
  }
  .special .item.wo{
    margin-right: 50px;
  }
  .special .icon{
    width: 32px;
    position: absolute;
    top: 22px;
    left: 20px;
  }
  .special .item .selected_img{
    display: none;
  }
  .special .item.selected .defalut_img{
    display: none;
  }
  .special .item.selected .selected_img{
    display: block;
  }
  .special .item .title{
    color: #333;
    /*font-weight: bold;*/
    font-size: 13px;
  }
  .special .item.selected .title{
    color: #1F8AFD;
  }
  .special .item .desc{
    color: #999;
    font-size: 12px;
    margin-top: 3px;
  }
  .special .ckbox_wrap{
    position: absolute;
    top: 0;
    right: 0;
    border-top-right-radius: 3px;
    border-left: 0.5px solid #D8D8D8;
    border-bottom: 0.5px solid #D8D8D8;
    padding: 2px;
  }
  .special .ckbox{
    width: 10px;
  }
  .special .ckbox.selected_ckbox{
    display: none;
  }
  .special .item.selected .ckbox{
    display: none;
  }
  .special .item.selected .ckbox_wrap{
    background-color: #1F8AFD;
    border-color: #1F8AFD;
  }
  .special .item.selected .ckbox.selected_ckbox{
    display: block;
  }
  .special_msg{
    margin: 15px 13px;
  }
  .rules{
    margin: 20px 60px 5px 13px;
  }
  .rules .items{
    margin-bottom: 25px;
  }
  .rules .items:last-child{
    margin-bottom: 0;
  }
  .rules .items .items_wrap{
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
  }
  .rules .items_title{
    position: relative;
    height: 48px;
    line-height: 48px;
    background-color: #F9F9F9;
  }
  .rules .items_title .items_title_value{
    font-size: 14px;
    color: #333;
    background: url("~@/assets/images/icons/show/guide.png") 15px center no-repeat transparent;
    background-size: 4px 12px;
    padding-left: 26px;
  }
  .rules .items_title .items_title_desc{
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: #949494;
    background: url("~@/assets/images/coo/icon_tixing.png") 0 center no-repeat transparent;
    background-size: 12px auto;
    padding-left: 17px;
  }
  .rules .items_rules{
    background: #fff;
    /*box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);*/
    padding: 15px;
  }
  .rules .item{
    height: 42px;
    line-height: 42px;
    margin-bottom: 5px;
  }
  .rules .item:last-child{
    margin-bottom: 0;
  }
  .rules .name{
    padding-right: 8px;
  }
  .rules .name .wrap{
    padding-left: 15px;
    background-color: #F9F9F9;
    white-space: nowrap;
  }
  .rules .other_item .items_rules{
    padding: 15px 0 0;
  }
  .rules .other_item .name .wrap{
    background-color: #fff;
    padding: 0 25px;
    white-space: normal;
    line-height: 1.5;
  }
  .rules .result.mr{
    padding-right: 15px;
  }
  .rules .result .wrap{
    background-color: rgba(31, 138, 253, 0.04);
    padding-left: 10px;
    white-space: nowrap;
  }
  .rules .result.error .wrap{
    background-color: rgba(255, 77, 77, 0.04);
    color: #FF4D4D;
  }
  .rules .result .wrap .jg{
    padding-right: 10px;
  }
  .rules .result .wrap .bz{
    background: url("~@/assets/images/coo/icon_tx.png") 0 center no-repeat transparent;
    background-size: 12px;
    padding-left: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/RulesDecide/zh-CN/VoteContentPanel.vue